module.exports = __webpack_public_path__ + "static/10.2_the_hebrew_kingdoms-f36baa18aa1f71cce525781f612fa6ae.pdf";